<tt-page *ngIf="!!edit">
    <tt-page-heading *ngIf="!!edit.metatable_name" [ttModel]="edit.metatable_name"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-select ttLabel="elementtype" [(ttModel)]="edit.elementtype" [ttData]="selectListElementTypes" ttDataId="elementtype" ttDataName="elementtype_name"></tt-select>

        <div *ngIf="metaColumnKeyno === '0'">
            <tt-input ttLabel="colname" [(ttModel)]="edit.colname" (ttOnBlur)="onBlur('colname')" ttRequired></tt-input>
            <tt-input ttLabel="colname_translated" [(ttModel)]="edit.colname_translated"></tt-input>
        </div>

        <div *ngIf="metaColumnKeyno !== '0'">
            <tt-input ttLabel="colname" [ttModel]="edit.colname" ttReadonly></tt-input>
            <tt-input ttLabel="colname_translated" [(ttModel)]="edit.colname_translated" [ttButtons]="columnNameTranslatedButtons"></tt-input>
        </div>

        <tt-checkbox ttLabel="isrequired" [(ttModel)]="edit.isrequired"></tt-checkbox>
        <tt-input *ngIf="!!edit.reg_by" ttLabel="reg_by" [ttModel]="edit.reg_by" ttReadonly></tt-input>
        <tt-input *ngIf="!!edit.mod_by" ttLabel="mod_by" [ttModel]="edit.mod_by" ttReadonly></tt-input>
        <tt-button-save ttText="metacolumn_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>

        <div *ngIf="metaColumnKeyno !== '0'">
            <tt-button ttText="metacolumn_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
            <tt-button-goto [hidden]="edit.elementtype !== 'CL'" [ttText]="'productsettingmcitem_new'" (ttClick)="goToFunc('metacolumnitem')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
        </div>
    </tt-card>

    <tt-list [hidden]="edit.elementtype !== 'CL'" class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListMetaColumns"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-header ng-if="vm.model.edit.metatable_name > ''" tt-model="vm.model.edit.metatable_name"></tt-header>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-select class="col-xs-12 sp-0" tt-label="elementtype" tt-model="vm.model.edit.elementtype" tt-change="vm.model.edit.elementtype = $value" tt-data="vm.model.selectListElementTypes" tt-data-id="elementtype" tt-data-name="elementtype_name"></tt-select>

        <div ng-if="vm.model.metaColumnKeyno === '0'">
            <tt-input class="col-xs-12 sp-0" tt-label="colname" tt-model="vm.model.edit.colname" tt-on-blur="vm.onBlur('colname')" tt-change="vm.model.edit.colname = $value" tt-readonly="false" tt-required="true"></tt-input>
            <tt-input class="col-xs-12 sp-0" tt-label="colname_translated" tt-model="vm.model.edit.colname_translated" tt-change="vm.model.edit.colname_translated = $value" tt-placeholder=""></tt-input>
        </div>

        <div ng-if="vm.model.metaColumnKeyno !== '0'">
            <tt-input class="col-xs-12 sp-0" tt-label="colname" tt-model="vm.model.edit.colname" tt-on-blur="vm.onBlur('colname')" tt-change="vm.model.edit.colname = $value" tt-readonly="true"></tt-input>
            <tt-input-buttons class="col-xs-12 sp-0" tt-label="colname_translated" tt-model="vm.model.edit.colname_translated" tt-change="vm.model.edit.colname_translated = $value" tt-placeholder="" tt-buttons="vm.model.colNameTranslatedButtons"></tt-input-buttons>
        </div>

        <tt-checkbox class="col-xs-12 sp-0" tt-label="isrequired" tt-model="vm.model.edit.isrequired" tt-change="vm.model.edit.isrequired = $value"></tt-checkbox>

        <div ng-if="vm.model.edit.reg_by > ''">
            <tt-input class="col-xs-12 sp-0" tt-label="reg_by" tt-model="vm.model.edit.reg_by" tt-change="vm.model.edit.reg_by = $value" tt-readonly="true"></tt-input>
        </div>

        <div ng-if="vm.model.edit.mod_by > ''">
            <tt-input class="col-xs-12 sp-0" tt-label="mod_by" tt-model="vm.model.edit.mod_by" tt-change="vm.model.edit.mod_by = $value" tt-readonly="true"></tt-input>
        </div>

        <tt-button-save class="col-xs-12 sp-0" tt-text="metacolumn_save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>

        <div ng-if="vm.model.metaColumnKeyno !== '0'">
            <tt-button class="col-xs-12 sp-0" tt-text="metacolumn_delete" tt-locked="vm.model.lockedDelete" tt-click="vm.deleteValues()" tt-icon="fas fa-trash-alt" tt-type="danger" tt-text-align="center"></tt-button>

            <div ng-if="vm.model.edit.elementtype === 'CL'">
                <tt-button-goto class="col-xs-12 sp-0" tt-text="productsettingmcitem_new" tt-goto="metacolumnitem" tt-goto-parms="vm.model.edit.metacolumn_keyno + '/0'" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button-goto>
                <tt-list class="col-xs-12 sp-0" list-items="vm.model.metaColumnItems" badge="" ltype="" design-var="s12t0"></tt-list>
            </div>
        </div>
    </tt-card>
</tt-page>-->
